"use strict";

exports.__esModule = true;
exports.CurrentPlantTime = void 0;
var _react = require("react");
var _TimeContext = require("../TimeContext");
var _libCalendar = require("@vimana/lib-calendar");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _class, _CurrentPlantTime;
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function calculatePlantTime(timezone) {
  var currentMillis = Date.now();
  var offset = (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, currentMillis);
  var localUTCOffset = new Date().getTimezoneOffset() * _timeDefinitions.MINUTE_IN_MILLIS;
  return new Date(currentMillis + offset + localUTCOffset);
}

/**
 * Provides access to the current plant time via a render prop.
 */
var CurrentPlantTime = exports.CurrentPlantTime = (_dec = _TimeContext.TimeContext.withContext, _dec(_class = (_CurrentPlantTime = /*#__PURE__*/function (_Component) {
  function CurrentPlantTime() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      plantTime: calculatePlantTime(_this.props.time.timezone)
    };
    _this.hasMounted = false;
    return _this;
  }
  _inheritsLoose(CurrentPlantTime, _Component);
  var _proto = CurrentPlantTime.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.hasMounted = true;
    this.requestNextTick();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hasMounted = false;
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  };
  _proto.requestNextTick = function requestNextTick() {
    var _this2 = this;
    var frequency = this.props.frequency;
    this.timer = setTimeout(function () {
      return _this2.tick();
    }, _timeDefinitions.SECOND_IN_MILLIS / frequency);
  };
  _proto.tick = function tick() {
    if (!this.hasMounted) {
      return;
    }
    var plantTime = calculatePlantTime(this.props.time.timezone);
    this.setState({
      plantTime: plantTime
    });
    this.requestNextTick();
  };
  _proto.render = function render() {
    var children = this.props.children;
    var plantTime = this.state.plantTime;
    return children(plantTime);
  };
  return CurrentPlantTime;
}(_react.Component), _CurrentPlantTime.defaultProps = {
  frequency: 1,
  time: undefined
}, _CurrentPlantTime)) || _class);